export { default } from './SeguroAuto25Cobertura';
